//import logo from './logo.svg';
import { useEffect } from 'react';
import './App.css';
import { useTelegram } from './hooks/useTelegram';
import Header from './components/Header/Header';
import Form from './components/Form/Form';
import ProductList from './components/ProductList/ProductList';
import {Route, Routes} from 'react-router-dom'

//const tg = window.Telegram.WebApp;
 
function App() {
 
  const {tg,onToggleButton} = useTelegram();
 
  useEffect( () => {
      tg.ready(); // прложение полносью проиницииалиировалось и его можно отрисовывать.
    }, []
  )
 
  return (
    <div className="App">

      <Header />
      <Routes>
        <Route index element={<ProductList />} />
        <Route path={'form/:chat_names?'} element={<Form />} />
      </Routes>
    </div>
  );
}
 
export default App;